module.exports = __webpack_public_path__ + "src/client/components/Header/header-background@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/Header/header-background@2x.png
// module id = 1207
// module chunks = 0